exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-section-container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 450px;\n  height: 100vh;\n  z-index: 999;\n  padding: 2rem 3rem 2rem 3rem;\n  background: #00d281;\n  transition: transform 0.2s ease-in-out;\n  transform: translate3d(100%, 0, 0); }\n  .about-section-container.open {\n    transform: translate3d(0, 0, 0); }\n  .about-section-container img {\n    margin-top: 20px;\n    max-width: 200px; }\n  .about-section-container h5 {\n    margin-bottom: -5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/shared/about-section/about-section.scss
// module id = 588
// module chunks = 0